<template>
    <div class="ado-history__dashboard">
        <div class="ado-history__header">
            <h5 class="ado-history__header-title">History</h5>
        </div>
        <div class="container-fluid pt-4 pb-4">
            <div class="ado-history__menu">
                <div class="row">
                    <div class="col-lg-8 ado-history__search-settings">
                        <div class="ado-history__title">Filter Settings</div>
                        <form id="searchFilter" ref="searchFilter" @submit.prevent="search()">
                            <input type="hidden" name="mode" id="mode" value="getQueueHistory">
                            <input v-model="department" type="hidden" name="department" id="department">
                            <div class="row">
                                <div class="col-xl-6">
                                    <div class="form-group">
                                        <label for="date">Date</label>
                                        <datepicker v-model="date" id="date" name="date" format="yyyy-MM-dd"
                                            :inline="true">
                                        </datepicker>
                                    </div>
                                </div>
                                <div class="col-xl-6">
                                    <div class="form-group">
                                        <label for="category">Search Category <small class="text-primary">(Not
                                                required)</small></label>
                                        <select v-model="category" class="form-control form-control-sm" id="category"
                                            name="category">
                                            <option value="name">Name</option>
                                            <option value="emplid">Student Number</option>
                                            <option value="emailid">Western Email</option>
                                        </select>
                                    </div>
                                    <div class="form-group">
                                        <label for="term">Search Term <small class="text-primary">(Not
                                                required)</small></label>
                                        <input v-model="term" type="text" class="form-control form-control-sm" id="term"
                                            name="term" placeholder="Search..." aria-describedby="Search Term">
                                    </div>
                                </div>
                            </div>
                        </form>
                        <div v-if="searchAlert" :class="['mb-2', 'text-right', setSearchAlert]">
                            <i v-if="searchType == 'success'" class="far fa-check"></i><i v-else
                                class="far fa-exclamation-circle"></i> {{ searchMessage }}
                        </div>
                        <button type="button" class="btn btn-sm btn-warning float-right" @click="clear()">
                            <i class="far fa-times"></i> Clear</button>
                        <button type="button" class="btn btn-sm btn-primary float-right mr-2" @click="search()"><i
                                v-if="!searchStatus" class="far fa-search"></i><i v-else
                                class="fas fa-spinner fa-spin"></i> Search</button>
                    </div>
                    <div class="col-lg-4">
                        <!-- EMPTY -->
                    </div>
                </div>
            </div>
            <div class="ado-history__content">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="ado-history__title"><i class="far fa-calendar-exclamation icon__warning"></i> In
                            Queue ({{ queueData.length }})</div>
                        <history-queue id="queue-items" :items="queueData" :counsellors="counsellorsData" :perPage="perPage"
                            :currentPage="queueCurrentPage">
                        </history-queue>
                        <div v-if="queueData.length > 0" class="overflow-auto">
                            <b-pagination v-model="queueCurrentPage" :total-rows="queuedRows" :per-page="perPage"
                                aria-controls="queue-items" align="center" class="m-0 mt-3"></b-pagination>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="ado-history__title"><i class="far fa-calendar-check icon__success"></i> Completed
                            ({{ dequeueData.length }})
                        </div>
                        <history-dequeue id="dequeue-items" :items="dequeueData" :counsellors="counsellorsData" :perPage="perPage"
                            :currentPage="dequeueCurrentPage">
                        </history-dequeue>
                        <div v-if="dequeueData.length > 0" class="overflow-auto">
                            <b-pagination v-model="dequeueCurrentPage" :total-rows="dequeuedRows" :per-page="perPage"
                                aria-controls="dequeue-items" align="center" class="m-0 mt-3"></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import HistoryDequeue from '../../components/History/Dequeue';
import HistoryQueue from '../../components/History/Queue';

const DEPARTMENT = `Academic Dean's Office`;

export default {
    name: 'ado-admin-history',
    components: {
        Datepicker,
        HistoryDequeue,
        HistoryQueue
    },
    data() {
        return {
            category: 'name',
            counsellorsData: [],
            counsellorsResult: '',
            dequeueCurrentPage: 1,
            dequeueData: [],
            date: new Date(),
            department: DEPARTMENT,
            perPage: 10,
            queueCurrentPage: 1,
            queueData: [],
            searchAlert: false,
            searchMessage: '',
            searchStatus: false,
            searchType: '',
            term: ''
        }
    },
    methods: {
        clear() {
            this.category = 'name';
            this.date = new Date();
            this.dequeueData = [];
            this.queueData = [];
            this.searchAlert = false;
            this.searchMessage = '';
            this.searchStatus = false;
            this.searchType = '';
            this.term = '';
        },
        getCounsellors() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?getCounsellorsData&department=${DEPARTMENT}`;

            // GET request
            fetch(api)
                .then(function (response) {
                    return response.json();
                })
                .then(function (json) {
                    // Store counsellors
                    if (json.result.match(/^OK/i)) {
                        that.counsellorsData = json.data;
                    } else {
                        that.counsellorsResult = 'ERROR';
                    }
                })
                .catch(function (error) {
                    that.counsellorsResult = 'ERROR';
                })
        },
        getQueueHistory() {
            const that = this;
            const api = `https://${location.hostname}/cgi-bin/mkvn-cardservices-backend/controller.cardservices.pl?GetQueueHistory&department=${DEPARTMENT}`;
            let formData = new FormData(this.$refs.searchFilter);

            // Set search status
            this.searchAlert = false;
            this.statusMessage = '';
            this.searchStatus = true;
            this.searchType = '';

            // GET request
            fetch(api, {
                    method: 'POST',
                    body: formData
                })
                .then(function (response) {
                    // Return response
                    return response.json();
                })
                .then(function (json) {
                    // API handler
                    if (json.result.match(/ok/i)) {
                        // Set search results data
                        that.queueData = json.queue;
                        that.dequeueData = json.dequeued;

                        let count = that.queueData.length + that.dequeueData.length;

                        that.searchAlert = true;
                        that.searchType = 'success';
                        that.searchMessage = `Search found ${count} matching records(s) for the specified date ${that.date.toISOString().slice(0,10)}.`;
                    } else {
                        // Render error alert
                        that.searchAlert = true;
                        that.searchType = 'warning';
                        that.searchMessage = 'An issue occurred during the search. Please contact your system administrator.';
                    }

                    // Reset search status
                    that.searchStatus = false;
                })
                .catch(function (error) {
                    // Reset search status
                    that.searchStatus = false;

                    // Render error alert
                    that.searchAlert = true;
                    that.searchType = 'danger';
                    that.searchMessage = 'An issue occurred during the search. Please contact your system administrator.';
                })
        },
        search() {
            // Fetch API
            this.getQueueHistory()
        }
    },
    computed: {
        dequeuedRows: function () {
            return this.dequeueData.length;
        },
        queuedRows: function () {
            return this.queueData.length;
        },
        setSearchAlert: function () {
            return {
                active: this.isActive && !this.error,
                'text-danger': this.searchType.match(/danger/i),
                'text-warning': this.searchType.match(/warning/i),
                'text-success': this.searchType.match(/success/i),
                'text-primary': !this.searchType
            }
        }
    },
    mounted() {
        this.date = new Date();
        this.getCounsellors();
    }
}
</script>

<style scoped>
.ado-history__content {
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 1.25rem;
}

.ado-history__header {
    font-size: 1.2rem;
    font-weight: 500;
    color: #434349;
    padding: 1rem;
    background-color: #fff;
    -webkit-box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
    box-shadow: 0px 10px 30px 0px rgba(82, 63, 105, 0.08);
}

.ado-history__header-title {
    font-weight: 600;
    margin: 0;
}

.ado-history__menu {
    -webkit-box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    box-shadow: 0 0 13px 0 rgba(82, 63, 105, .05);
    background-color: #fff;
    margin-bottom: 20px;
    border-radius: 4px;
    padding: 1.25rem;
}

.ado-history__search-settings {
    border-right: 1px solid #eff0f6;
}

.ado-history__title {
    color: #48465b;
    font-size: 16px;
    font-weight: 700;
    margin-bottom: 1rem;
}

@media (max-width: 991.98px) {
    .ado-history__search-settings {
        border: none;
        border-bottom: 1px solid #eff0f6;
        margin-bottom: 1rem;
        padding-bottom: 1rem;
    }
}
</style>